<div class='ebill-sso-container'>
    <a (click)="ssoEbill()">{{ label }}</a>
</div>
